// Temats värde hamnar i data-theme, cookie och User.tema (String utan
// enum-constraint) — inget schema-arbete behövs för att lägga till eller ta
// bort ett tema. vektr har bara ljusa teman (Erik 2026-10-31: aldrig mörkt).
export type Theme = "morgon" | "krit" | "skala" | "chroma";

export const DEFAULT_THEME: Theme = "morgon";
export const THEME_COOKIE = "vektr-theme";
export const THEME_STORAGE_KEY = "vektr-theme";

/**
 * Teman som faktiskt erbjuds just nu.
 *
 * Ett tema som saknas här är avstängt, och då gäller tre saker samtidigt:
 * temat visas inte som val i /installningar, skrivvägen `PATCH /api/user/theme`
 * nekar det, och ett redan sparat värde (cookie eller `User.tema`) faller
 * tillbaka på default via `resolveTheme`. Ett okänt värde (t.ex. ett borttaget
 * tema som ligger kvar i en gammal cookie) behandlas likadant.
 */
export const AKTIVA_TEMAN: readonly Theme[] = [
  "morgon",
  "krit",
  "skala",
  "chroma",
];

/**
 * Syntaktisk giltighet — är strängen ett tema vi känner till?
 *
 * Skild från `arAktivtTema` med flit: API:t behöver kunna skilja "det där är
 * inget tema alls" (400, felaktig indata) från "det temat är avstängt" (403).
 */
export function isTheme(value: string | null | undefined): value is Theme {
  return (
    value === "morgon" ||
    value === "krit" ||
    value === "skala" ||
    value === "chroma"
  );
}

/** Är temat både känt OCH påslaget just nu? */
export function arAktivtTema(value: string | null | undefined): value is Theme {
  return isTheme(value) && AKTIVA_TEMAN.includes(value);
}

/**
 * Cookie-/DB-värde → tema att faktiskt rendera. Okända OCH avstängda värden
 * faller tillbaka på default, så ett tema kan stängas av utan att någon som
 * redan har det sparat blir kvar i det.
 */
export function resolveTheme(raw: string | null | undefined): Theme {
  return arAktivtTema(raw) ? raw : DEFAULT_THEME;
}
